import { Alert, AlertIcon, Box, Flex, Spinner, Text } from '@chakra-ui/react'

import { Button } from '../Buttons/Button'

interface MatchSearchStatusProps {
  state: 'idle' | 'pending' | 'done' | 'error'
  matchCount: number
  unavailableCount: number
  error?: string
  onRetry: () => void
}

export const MatchSearchStatus = ({ state, matchCount, unavailableCount, error, onRetry }: MatchSearchStatusProps) => {
  if (state === 'idle' || state === 'pending') {
    return (
      <Flex w="100%" alignItems="center" justifyContent="center">
        <Spinner thickness="4px" speed="0.75s" emptyColor="cls.gray.200" color="cls.blue.400" size="xl" />
        <Text ml="14px" fontWeight="bold" fontSize="2xl">
          Loading
        </Text>
      </Flex>
    )
  }

  if (state === 'error') {
    return (
      <Alert status="error" role="alert" mb="14px">
        <AlertIcon />
        <Box flex="1">{error || 'Unable to load matches. Please retry.'}</Box>
        <Button onClick={onRetry}>Retry</Button>
      </Alert>
    )
  }

  if (unavailableCount > 0) {
    return (
      <Alert status="warning" role="alert" mb="14px">
        <AlertIcon />
        <Box flex="1">
          {unavailableCount} {unavailableCount === 1 ? 'match is' : 'matches are'} unavailable because of incompatible
          data. {matchCount > 0 ? 'Other matches remain available.' : 'No compatible matches could be loaded.'} Please
          contact support if your match is missing.
        </Box>
        <Button onClick={onRetry}>Retry</Button>
      </Alert>
    )
  }

  return matchCount === 0 ? <Text>No matches found for these dates.</Text> : null
}
